var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExpandMore } from "@mui/icons-material";
import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { FormContext } from "../../../common/context/context";
import { ActionType } from "../../../common/enums/action-type";
import { I18nLangs } from "../../../common/enums/i18-langs";
import { LocalStorageKeys } from "../../../common/enums/local-storage-keys";
import icons from "../../../icons/index";
import { ApiI18 } from "../../../network/api";
import { LangHelper } from "./helper";
var LangSwitcher = function () {
    var _a = React.useContext(FormContext), state = _a.state, dispatch = _a.dispatch;
    var newTitle = LangHelper.getLangMessageValue("GAD.website.title", state.lang);
    var newDescription = LangHelper.getLangMessageValue("GAD.website.description", state.lang);
    var changeLanguage = function (lang) {
        dispatch({
            lang: lang,
            type: ActionType.CHANGE_LANG,
        });
    };
    var _b = useState(false), isMobileView = _b[0], setIsMobileView = _b[1];
    useEffect(function () {
        var handleResize = function () {
            setIsMobileView(window.innerWidth <= 1024);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return function () {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    var renderLangs = function () {
        var _a, _b;
        return (_jsxs(_Fragment, { children: [isMobileView ? (_jsx("div", __assign({ className: "lang_dropdown" }, { children: _jsx(FormControl, __assign({ sx: { m: 0 }, size: "small" }, { children: _jsx(Select, __assign({ className: "lang_select", IconComponent: ExpandMore, value: "".concat(state.lang), sx: {
                                ".MuiSelect-icon": {
                                    color: "white",
                                },
                            } }, { children: (_a = state.langList) === null || _a === void 0 ? void 0 : _a.map(function (lang) { return (_jsx(MenuItem, __assign({ value: "".concat(lang.value), onClick: function () { return changeLanguage(lang.value); } }, { children: _jsxs("div", __assign({ style: { alignItems: "center", display: 'flex' } }, { children: [_jsx("img", { src: lang.icoSrc, className: "lang_flag", alt: "".concat(lang.value) }), _jsx("span", __assign({ className: "lang_span" }, { children: lang.value }))] })) }), "".concat(lang.value))); }) })) })) }))) : (_jsx("div", __assign({ className: "lang_div" }, { children: (_b = state.langList) === null || _b === void 0 ? void 0 : _b.map(function (lang) { return (_jsxs(MenuItem, __assign({ value: "".concat(lang.value), className: "".concat(state.lang === lang.value ? "active" : "", " language"), onClick: function () { return changeLanguage(lang.value); } }, { children: [_jsx("img", { src: lang.icoSrc, className: "lang_flag", alt: "".concat(lang.value) }), _jsx("span", __assign({ className: "lang_span" }, { children: lang.value }))] }), "".concat(lang.value))); }) }))), _jsx(HelmetProvider, { children: _jsxs(Helmet, { children: [_jsx("title", { children: newTitle }), _jsx("meta", { name: "description", content: newDescription })] }) })] }));
    };
    useEffect(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var languages, response, _a, langs, version, existsVersion, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        languages = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, ApiI18.fetchLangsList()];
                    case 2:
                        response = _b.sent();
                        if (!(response && response.data)) return [3 /*break*/, 4];
                        if (!(response.data.code === 200 && response.data.payload)) return [3 /*break*/, 4];
                        _a = response.data.payload, langs = _a.langs, version = _a.version;
                        langs.forEach(function (lang) {
                            if (lang in I18nLangs) {
                                languages.push({
                                    icoSrc: icons[String("flag_".concat(lang.toLowerCase()))],
                                    value: lang,
                                });
                            }
                        });
                        existsVersion = parseInt(String(localStorage.getItem(LocalStorageKeys.LANG_VERSION)), 10);
                        if (!((version && existsVersion && existsVersion < version) || (version && !existsVersion))) return [3 /*break*/, 4];
                        localStorage.setItem(LocalStorageKeys.LANG_VERSION, String(version));
                        return [4 /*yield*/, LangHelper.setLangData().catch(console.error)];
                    case 3:
                        _b.sent();
                        // Force switch to default lang after lang data was getted
                        changeLanguage(state.lang);
                        _b.label = 4;
                    case 4:
                        dispatch({
                            langList: __spreadArray([], LangHelper.sortLangByOrder(languages), true),
                            type: ActionType.REFRESH_LANG_LIST,
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchData().catch(console.error);
    }, []);
    return (_jsx(_Fragment, { children: renderLangs() }));
};
export default LangSwitcher;
